<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-user-shield"></i></span>{{ 'ChangePwd.Header' | translate }}</h1>
    <p-card>
        <form [formGroup]="changeForm">
            <div class="p-fluid formgrid grid">
                <div class="field col-12">
                    <label>{{ 'ChangePwd.Form.OldPwd' | translate }}</label>
                    <input type="password" pPassword [(ngModel)]="oldPassword" formControlName="oldPassword" />
                    <small *ngIf="submitted && f.oldPassword.errors" class="errors">
                      <div *ngIf="f.oldPassword.errors.required" class="p-invalid">{{ 'ChangePwd.Form.OldPwd' | translate }} is required</div>
                    </small>
                </div>
                <div class="field col-12">
                    <label>{{ 'ChangePwd.Form.NewPwd' | translate }}</label>
                    <input type="password" pPassword [(ngModel)]="newPassword" formControlName="newPassword" />
                    <small *ngIf="submitted && f.newPassword.errors" class="errors">
                      <div *ngIf="f.newPassword.errors.required" class="p-invalid">{{ 'ChangePwd.Form.NewPwd' | translate }} is required</div>
                    </small>
                </div>
                <div class="field col-12">
                    <label>{{ 'ChangePwd.Form.ConfirmPwd' | translate }}</label>
                    <input type="password" pPassword [(ngModel)]="rePassword" formControlName="rePassword" />
                    <small *ngIf="submitted && f.rePassword.errors" class="errors">
                      <div *ngIf="f.rePassword.errors.required" class="p-invalid">{{ 'ChangePwd.Form.ConfirmPwd' | translate }} is required</div>
                    </small>
                </div>
            </div>
            <div class="grid mt-5">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="changePassword($event)"></button>
                </div>
            </div>
        </form>
    </p-card>
</div>
